import { render, staticRenderFns } from "./PriceDemo.vue?vue&type=template&id=458558f2&scoped=true"
import script from "./PriceDemo.vue?vue&type=script&lang=js"
export * from "./PriceDemo.vue?vue&type=script&lang=js"
import style0 from "./PriceDemo.vue?vue&type=style&index=0&id=458558f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458558f2",
  null
  
)

export default component.exports